import mitt from "mitt";

export type Events = {
    toggleFavouriteDeviceGroup: void;
};

export const eventEmitter = mitt<Events>();
